import PaginatedResults from '../../helpers/PaginatedResults'

export default {
    job: null,
    assets: [],
    comments: new PaginatedResults(),
    members: [],
    parentComment: null
}
